import React, { Component } from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LandingPage from './Pages/LandingPage';

class App extends Component {
  render() {
    return (
      <>
        <Router>
          <div data-theme="luxury" className="App">
            {/* <Navbar /> */}
            <Routes>
              <Route exact path="/" element={<LandingPage />}></Route>
              {/* <Route exact path="/photography" element={<HomePhoto />}></Route>
              <Route exact path="/web" element={<HomeWeb />}></Route>
              <Route exact path="/photography/auto" element={<PhotoAuto />}></Route> */}
            </Routes>
          </div>
        </Router>
      </>
    );
  }
}

export default App;
